import { render, staticRenderFns } from "./TruckShipmentForm.vue?vue&type=template&id=4806b4d4&scoped=true"
import script from "./TruckShipmentForm.vue?vue&type=script&lang=js"
export * from "./TruckShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./TruckShipmentForm.vue?vue&type=style&index=0&id=4806b4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806b4d4",
  null
  
)

export default component.exports